// src/components/tableros/constants/defaultSettings.js
export const defaultSettings = {
    tableWidth: 600,
    tableHeight: 600,
    tableBackgroundColor: '#1a1a1a',
    globalFontColor: '#ffffff',
    timerColor: '#00ff00',
    headerFontSize: 24,
    nameFontSize: 18,
    positionFontSize: 20,
    timeFontSize: 18,
    stopwatchSize: 50,
    largeStopwatchSize: 120,
    headerFontColor: '#ffffff',
    athleteNameColor: '#ffffff',
    teamNameColor: '#9e9c9c',
    resultTimeColor: '#ffffff',
    deltaTimeColor: '#c1ff30',
    positionColor: '#ffffff',
    tableRowOddColor: '#252525',
    tableRowEvenColor: '#1e1e1e',
  };